import { Button } from '@coop/components';
import { SwitchIcon } from '@coop/icons';

import { useFocusRestore } from '../../../../common/components/FocusRestoreProvider';
import {
    type ItemToSubstitute,
    useRecipeProductSubstitutionContext,
} from '../../../../ecommerce/contexts/RecipeProductSubstitutionContext';

const RecipeProductSubstituteTrigger = (props: {
    item: ItemToSubstitute;
    'aria-haspopup'?: React.ComponentPropsWithoutRef<'button'>['aria-haspopup'];
}) => {
    const { ref, onFocus } = useFocusRestore<HTMLButtonElement>(props.item.stableId);
    const { setItemToSubstitute } = useRecipeProductSubstitutionContext();

    return (
        <Button
            ref={ref}
            theme="white"
            onClick={() => setItemToSubstitute(props.item)}
            aria-label={`Byt vara ${props.item.name}`}
            onFocus={onFocus}
            size={32}
            icon={SwitchIcon}
            aria-haspopup={props['aria-haspopup']}
        >
            Byt vara
        </Button>
    );
};

export default RecipeProductSubstituteTrigger;
